import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useTheme } from "styled-components";
import Modal from "@/components/modal/Modal";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import Sheet from "react-modal-sheet";
import { SelectingBooksModal } from "../UserSourceStep";
export const UserSourceStepModal = (param)=>{
    let { closeSelectBooksModal , ...props } = param;
    const { width  } = useWindowDimensions();
    const isMobile = width < 769;
    const theme = useTheme();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: !isMobile ? /*#__PURE__*/ _jsx(Modal, {
            disableOutsideClick: true,
            onClose: closeSelectBooksModal,
            open: props.isSelectBooksModalOpen,
            name: "selectBooksModal",
            children: /*#__PURE__*/ _jsx(SelectingBooksModal, {
                ...props,
                onClose: closeSelectBooksModal
            })
        }) : /*#__PURE__*/ _jsxs(Sheet, {
            isOpen: props.isSelectBooksModalOpen,
            onClose: closeSelectBooksModal,
            children: [
                /*#__PURE__*/ _jsx(Sheet.Container, {
                    children: /*#__PURE__*/ _jsx(Sheet.Content, {
                        children: /*#__PURE__*/ _jsx(SelectingBooksModal, {
                            ...props,
                            onClose: closeSelectBooksModal
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Sheet.Backdrop, {})
            ]
        })
    });
};
